import { render, staticRenderFns } from "./StudyControls.vue?vue&type=template&id=14ddc908&scoped=true&"
import script from "./StudyControls.vue?vue&type=script&lang=js&"
export * from "./StudyControls.vue?vue&type=script&lang=js&"
import style0 from "./StudyControls.vue?vue&type=style&index=0&id=14ddc908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ddc908",
  null
  
)

export default component.exports